<form [formGroup]="setupForm">
  <div class="setup-intro">
    <p>
      Use this tile to present content in multiple columns. Configure the shared tile styling
      first, then define the heading, text, and divider settings for each column.
    </p>
  </div>

  <section class="editor-section">
    <div class="editor-section__header">
      <h2>Settings</h2>
    </div>
    <div class="editor-section__content editor-section__content--spacious">
      <p class="section-intro">These settings affect the whole tile rather than a single column.</p>
      <mat-checkbox class="example-margin" formControlName="isTileDividerEnabled"
        >Tile Divider</mat-checkbox
      >

      <p class="section-intro" *ngIf="setupForm?.controls?.isTileDividerEnabledControl?.value">
        These fields control the divider shown between the tile sections.
      </p>

      <div class="tile-divider-settings" *ngIf="setupForm?.controls?.isTileDividerEnabledControl?.value">
        <lib-color-picker-square
          [formGroup]="setupForm"
          controlName="tileDividerColor"
          inputId="tileDividerColor"
          label="Tile Divider Color"
          hint="Sets the color used for the tile divider."
        ></lib-color-picker-square>

        <mat-form-field appearance="outline" class="tile-divider-settings__position">
          <mat-label>Tile Divider Position</mat-label>
          <mat-select formControlName="tileDividerPosition">
            <mat-option
              *ngFor="let positionOption of verticalPositionsOptions"
              [value]="positionOption.key"
            >
              {{ positionOption.name }}
            </mat-option>
          </mat-select>
          <mat-hint>Controls where the divider is aligned within the tile.</mat-hint>
        </mat-form-field>
      </div>

      <div class="inputs-container">
        <mat-form-field appearance="fill">
          <mat-label>Background</mat-label>
          <input matInput formControlName="background" />
          <mat-hint>Defines the background shown behind all columns.</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </section>
  <hr class="editor-divider" />

  <section class="editor-section">
    <div class="editor-section__header">
      <h2>Text Columns</h2>
    </div>
    <div class="editor-section__content editor-section__content--spacious">
      <p class="section-intro">
        Each column can have its own heading, body text, and optional divider styling.
      </p>
      <div
        *ngFor="let textColumn of textColumns.controls; let i = index"
        [formGroup]="textColumn"
        class="text-columns-container"
      >
        <div class="text-column-form">
          <div class="text-column-form__header">
            <h3>Column {{ i + 1 }}</h3>
            <button type="button" mat-icon-button aria-label="Remove text column" (click)="removeTextColumn(i)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>

          <div class="text-column-copy-group">
            <div class="text-column-copy-group__controls">
              <mat-form-field appearance="outline" class="font-size-field">
                <mat-label>Heading Size</mat-label>
                <mat-select formControlName="headingFontSize">
                  <mat-option *ngFor="let sizeOption of fontSizesOptions" [value]="sizeOption">
                    {{ sizeOption }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <lib-color-picker-square
                [formGroup]="textColumn"
                controlName="headingFontColor"
                [inputId]="'text-column-heading-color-' + i"
                ariaLabel="Heading colour"
              ></lib-color-picker-square>
            </div>

            <mat-form-field appearance="fill" class="text-column-copy-group__field">
              <mat-label>Heading</mat-label>
              <input matInput formControlName="heading" />
              <mat-hint>Sets the column heading.</mat-hint>
            </mat-form-field>
          </div>

          <div class="text-column-copy-group">
            <div class="text-column-copy-group__controls">
              <mat-form-field appearance="outline" class="font-size-field">
                <mat-label>Text Size</mat-label>
                <mat-select formControlName="textFontSize">
                  <mat-option *ngFor="let sizeOption of fontSizesOptions" [value]="sizeOption">
                    {{ sizeOption }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <lib-color-picker-square
                [formGroup]="textColumn"
                controlName="textFontColor"
                [inputId]="'text-column-text-color-' + i"
                ariaLabel="Text colour"
              ></lib-color-picker-square>
            </div>

            <mat-form-field appearance="fill" class="text-column-copy-group__field">
              <mat-label>Text</mat-label>
              <textarea matInput formControlName="text" rows="4"></textarea>
              <mat-hint>Defines the main body copy for the column.</mat-hint>
            </mat-form-field>
          </div>

          <div class="text-column-divider-group">
            <mat-checkbox class="example-margin" formControlName="isDividerEnabled">Divider</mat-checkbox>

            <div class="text-column-divider-group__controls" *ngIf="textColumn.get('isDividerEnabled').value">
              <lib-color-picker-square
                [formGroup]="textColumn"
                controlName="dividerColor"
                [inputId]="'text-column-divider-color-' + i"
                label="Divider Colour"
                hint="Sets the color used for this column divider."
              ></lib-color-picker-square>

              <mat-form-field appearance="outline" class="text-column-divider-group__position">
                <mat-label>Divider Position</mat-label>
                <mat-select formControlName="dividerPosition">
                  <mat-option
                    *ngFor="let positionOption of verticalPositionsOptions"
                    [value]="positionOption.key"
                  >
                    {{ positionOption.name }}
                  </mat-option>
                </mat-select>
                <mat-hint>Controls where this divider sits relative to the column content.</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <button class="add-btn" mat-raised-button color="primary" (click)="addTextColumn()">
        Add Text Column
      </button>
    </div>
  </section>
</form>

<div class="footer">
  <button mat-flat-button color="primary" (click)="onCreate()">Apply</button>
</div>
